import { render, staticRenderFns } from "./ChevronIcon.vue?vue&type=template&id=704f4530&scoped=true"
import script from "./ChevronIcon.vue?vue&type=script&lang=js"
export * from "./ChevronIcon.vue?vue&type=script&lang=js"
import style0 from "./ChevronIcon.vue?vue&type=style&index=0&id=704f4530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704f4530",
  null
  
)

export default component.exports